import { Link, useNavigate } from "react-router-dom";
import { Trash2, Plus, Minus, ShoppingBag } from "lucide-react";
import AppHeader from "@/components/AppHeader";
import { useCart } from "@/context/CartContext";
import { useCurrency } from "@/context/CurrencyContext";
import { formatPrice } from "@/lib/constants";

export default function Cart() {
  const { items, removeItem, setQuantity, subtotal, count } = useCart();
  const { currency } = useCurrency();
  const navigate = useNavigate();

  return (
    <>
      <AppHeader title="Mi Carrito" />
      <main className="page-scroll px-4 pt-3" data-testid="cart-page">
        {items.length === 0 ? (
          <div className="text-center py-16">
            <div className="w-16 h-16 mx-auto rounded-full bg-[#EEF3FF] flex items-center justify-center">
              <ShoppingBag size={28} className="text-[#0A2A66]" />
            </div>
            <h2 className="font-heading text-lg font-bold text-[#0A2A66] mt-4">Tu carrito está vacío</h2>
            <p className="text-sm text-slate-500 mt-1">Explora nuestro catálogo y comienza a aprender.</p>
            <Link to="/catalogo" className="navy-btn inline-block mt-5 px-6 py-3 text-sm" data-testid="cart-explore-btn">
              Ver programas
            </Link>
          </div>
        ) : (
          <>
            <div className="space-y-3">
              {items.map((it) => (
                <div key={it.product_id} className="card-clean p-3 flex gap-3" data-testid={`cart-item-${it.product_id}`}>
                  {it.image && <img src={it.image} alt="" className="w-20 h-20 rounded-xl object-cover" />}
                  <div className="flex-1 min-w-0">
                    <div className="font-heading text-sm font-bold text-[#0A2A66] line-clamp-2">{it.title}</div>
                    <div className="text-[#F5B914] font-bold text-sm mt-1">{formatPrice(it.price_usd, currency)}</div>
                    <div className="mt-2 flex items-center gap-2">
                      <button
                        onClick={() => setQuantity(it.product_id, it.quantity - 1)}
                        className="w-7 h-7 rounded-full bg-slate-100 flex items-center justify-center active:scale-95"
                        data-testid={`decrement-${it.product_id}`}
                      >
                        <Minus size={14} />
                      </button>
                      <span className="w-6 text-center text-sm font-semibold">{it.quantity}</span>
                      <button
                        onClick={() => setQuantity(it.product_id, it.quantity + 1)}
                        className="w-7 h-7 rounded-full bg-slate-100 flex items-center justify-center active:scale-95"
                        data-testid={`increment-${it.product_id}`}
                      >
                        <Plus size={14} />
                      </button>
                      <button
                        onClick={() => removeItem(it.product_id)}
                        className="ml-auto w-8 h-8 rounded-full text-red-500 hover:bg-red-50 flex items-center justify-center"
                        data-testid={`remove-${it.product_id}`}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="card-clean p-4 mt-4">
              <div className="flex justify-between text-sm text-slate-600">
                <span>Items</span>
                <span>{count}</span>
              </div>
              <div className="flex justify-between text-sm text-slate-600 mt-1">
                <span>Subtotal</span>
                <span>{formatPrice(subtotal, currency)}</span>
              </div>
              <div className="border-t border-slate-100 my-3" />
              <div className="flex justify-between">
                <span className="font-heading text-base font-bold text-[#0A2A66]">Total</span>
                <span className="font-heading text-lg font-extrabold text-[#0A2A66]" data-testid="cart-total">
                  {formatPrice(subtotal, currency)}
                </span>
              </div>
              <button
                onClick={() => navigate("/checkout")}
                data-testid="checkout-btn"
                className="gold-btn w-full mt-4 py-3.5"
              >
                Ir al checkout
              </button>
            </div>
          </>
        )}
      </main>
    </>
  );
}
